class CartAjaxItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    //Add margin to items
    document.querySelector('.cart-ajax__body').style.marginBottom = document.getElementById('cart-ajax-footer').getBoundingClientRect().height + "px"
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-ajax-items',
        section: 'cart-ajax-items',
        selector: '.js-contents',
      },
      {
        id: 'cart-ajax-footer',
        section: 'cart-ajax-footer',
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('cart-ajax-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        var evt = new Event("cart-changed");
        document.dispatchEvent(evt)
      }).catch((e) => {
        console.log(e)
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('cart-ajax-items').classList.add('cart-ajax__container--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('cart-ajax-items').classList.remove('cart-ajax__container--disabled');
  }
}

customElements.define('cart-ajax-items', CartAjaxItems);


class CartAjax extends HTMLElement {
  constructor() {
    super();

    this.cart = this.querySelector('.cart-ajax');
    this.transparentHeader = document.querySelector('.header--transparent');

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.triggers = document.querySelectorAll('.js-cart-ajax-toggle')

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('.cart-ajax__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', this.open.bind(this));
    })
  }

  open(evt) {
    if (evt) {
      evt.preventDefault();
      evt.target.classList.add('active');
    }

    this.cart.classList.add('active');

    if (this.transparentHeader) {
      this.transparentHeader.classList.remove('header--transparent');
    }

    document.body.classList.add('overflow-hidden');

    this.cart.addEventListener('transitionend', () => {
      this.cart.focus();
      trapFocus(this.cart);
    }, { once: true });

    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClick);
    }, 100)

    //Add margin to items
    document.querySelector('.cart-ajax__body').style.marginBottom = document.getElementById('cart-ajax-footer').getBoundingClientRect().height + "px"
  }

  close() {
    this.cart.classList.remove('active');

    this.triggers.forEach(trigger => {
      trigger.classList.remove('active')
    });

    if (this.transparentHeader && window.scrollY < 50) {
      this.transparentHeader.classList.add('header--transparent');
    }

    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-ajax-items',
        section: 'cart-ajax-items',
        selector: '.js-contents'
      },
      {
        id: 'cart-ajax-footer',
        section: 'cart-ajax-footer',
        selector: '.js-contents'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.cart && !target.closest('cart-ajax')) {
      const disclosure = target.closest('details-modal');

      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-ajax', CartAjax);
